import { render, staticRenderFns } from "./OptionsComponent.vue?vue&type=template&id=379c89cf&scoped=true"
import script from "./OptionsComponent.vue?vue&type=script&lang=js"
export * from "./OptionsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379c89cf",
  null
  
)

export default component.exports